import { Building2, Users, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export function CTASection() {
  return (
    <section className="relative py-24 bg-gradient-to-br from-primary via-primary to-primary/90 text-primary-foreground overflow-hidden">
      {/* Animated Gradient Orbs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 -left-20 w-96 h-96 bg-primary-foreground/10 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-20 -right-20 w-[500px] h-[500px] bg-primary-foreground/10 rounded-full blur-3xl animate-float animation-delay-200"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary-foreground/5 rounded-full blur-3xl animate-pulse"></div>
      </div>
      
      {/* Geometric Pattern Overlay */}
      <div className="absolute inset-0 opacity-10">
        <svg className="absolute bottom-0 w-full h-40" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="currentColor"></path>
        </svg>
      </div>
      
      {/* Decorative Pattern Elements */}
      <div className="absolute inset-0 opacity-[0.07]">
        <div className="absolute top-10 left-10 w-40 h-40 border-4 border-primary-foreground rotate-12 rounded-2xl animate-spin-slow"></div>
        <div className="absolute bottom-32 right-24 w-32 h-32 border-4 border-primary-foreground rounded-full animate-pulse"></div>
        <div className="absolute top-1/3 right-1/4 w-24 h-24 border-4 border-primary-foreground rotate-45 rounded-lg animate-float"></div>
        <div className="absolute bottom-1/4 left-1/4 w-28 h-28 bg-primary-foreground/20 rotate-12 rounded-2xl animate-pulse animation-delay-100"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* For Organizations */}
          <div className="relative bg-primary-foreground/15 backdrop-blur-xl rounded-3xl p-10 text-center hover:bg-primary-foreground/20 transition-all duration-500 border-2 border-primary-foreground/30 hover:border-primary-foreground hover:shadow-2xl hover:-translate-y-3 group overflow-hidden animate-fade-in">
            {/* Animated gradient glow */}
            <div className="absolute inset-0 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-br from-primary-foreground/20 via-transparent to-primary-foreground/10"></div>
            
            {/* Icon container with gradient background */}
            <div className="relative z-10 mb-6 inline-block">
              <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-primary-foreground/20 to-primary-foreground/10 flex items-center justify-center mx-auto group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg">
                <Building2 className="h-12 w-12 text-primary-foreground" strokeWidth={2.5} />
              </div>
            </div>
            
            <h3 className="text-3xl font-poppins font-bold mb-4 relative z-10">
              Vous recrutez ?
            </h3>
            <p className="text-primary-foreground/95 font-inter mb-8 relative z-10 text-lg leading-relaxed">
              Publiez vos offres gratuitement et trouvez les meilleurs talents de Brazzaville en quelques clics.
            </p>
            <Link to="/publish-opportunity">
              <Button variant="secondary" size="lg" className="w-full relative z-10 text-base font-semibold h-14 hover:scale-105 transition-transform shadow-xl">
                Publier une offre gratuitement
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>
          
          {/* For Candidates */}
          <div className="relative bg-primary-foreground/15 backdrop-blur-xl rounded-3xl p-10 text-center hover:bg-primary-foreground/20 transition-all duration-500 border-2 border-primary-foreground/30 hover:border-primary-foreground hover:shadow-2xl hover:-translate-y-3 group overflow-hidden animate-fade-in animation-delay-100">
            {/* Animated gradient glow */}
            <div className="absolute inset-0 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-br from-primary-foreground/10 via-transparent to-primary-foreground/20"></div>
            
            {/* Icon container with gradient background */}
            <div className="relative z-10 mb-6 inline-block">
              <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-primary-foreground/20 to-primary-foreground/10 flex items-center justify-center mx-auto group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg">
                <Users className="h-12 w-12 text-primary-foreground" strokeWidth={2.5} />
              </div>
            </div>
            
            <h3 className="text-3xl font-poppins font-bold mb-4 relative z-10">
              Vous cherchez une opportunité ?
            </h3>
            <p className="text-primary-foreground/95 font-inter mb-8 relative z-10 text-lg leading-relaxed">
              Inscrivez-vous pour sauvegarder vos opportunités préférées et ne manquer aucune nouveauté.
            </p>
            <Link to="/opportunities">
              <Button variant="secondary" size="lg" className="w-full relative z-10 text-base font-semibold h-14 hover:scale-105 transition-transform shadow-xl">
                Explorer les opportunités
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}